export default "__VITE_ASSET__EGuSg26M__"